import { withStyles } from "@material-ui/core";
import { Tooltip as MuiTooltip } from "@material-ui/core";

export const Tooltip = withStyles((theme) => ({}))(MuiTooltip);
